<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<div v-if="$store.getters.isAuthorized(['ROLE_MANAGER'])" class="form-row">
										<div align="center" class="col-md-6">
											<button class="btn btn-primary btn-sm" @click="modalToggle('NEW')" >
												<fa icon="add"/>&nbsp;
												{{ $t('default.button.add') }}
											</button>
										</div>
									</div>
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
												</label>
												<select v-model="instance.prsStore" class="form-control" multiple>
													<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
													{{ prsStore.storeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.username')}}
												</label>
												<select v-model="instance.username" class="form-control" multiple>
													<option v-for="user in userList" :value="user" :key="user">
														{{ user}}
													</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servTypeES')}}
												</label>
												<select v-model="instance.servTypeES" class="form-control" multiple>
													<option v-for="servTypeES in servTypeESList" :value="servTypeES.id" :key="servTypeES.id">
														{{ servTypeES.typeESName}}
													</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servCategory')}}
												</label>
												<select v-model="instance.servCategory" class="form-control" multiple>
													<option v-for="servCategory in servCategoryList" :value="servCategory.id" :key="servCategory.id">
													{{ servCategory.categoryName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servService')}}
												</label>
												<select v-model="instance.servService" class="form-control" multiple>
													<option v-for="servService in servServiceList" :value="servService.id" :key="servService.id">
													{{ servService.serviceName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servType')}}
												</label>
												<select v-model="instance.servType" class="form-control" multiple>
													<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id">
													{{ servType.typeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servTypeStockES')}}
												</label>
												<select v-model="instance.servTypeStockES" class="form-control" multiple>
													<option v-for="servTypeStockES in servTypeStockESList" :value="servTypeStockES.id" :key="servTypeStockES.id">
													{{ servTypeStockES.lib}}
													</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>

									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>

			<!-- ModalInstance  -->
			<div ref="modalInstance" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-dialog-centered modal-lg"
					role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" v-if="modalType == 'NEW'">
								{{ $t('default.new') }}
							</h5>
							<h5 class="modal-title" v-if="modalType == 'EDIT'">
								{{ $t('default.edit') }}
							</h5>
							<b-button type="button" variant="close" @click="modalToggle()" />
						</div>
						<div class="modal-body">
							<b-container>
								<form role="form" id="modalFormInst" @submit.prevent="axiosPost">
									<div class="row d-flex justify-content-center ">
										<div class="col-md-12">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servTypeStockES')}}
												</label>
												<select v-model="instanceModal.servTypeStockES" class="form-control">
													<option v-for="servTypeStockES in servTypeStockESList" :value="servTypeStockES.id" :key="servTypeStockES.id">
													{{ servTypeStockES.lib}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.quantity')}}
											</label>
											<input type="number" v-model="instanceModal.quantity" class="form-control" />
										</div>
										<div class="col-md-4">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.dateOp')}}
											</label>
											<input type="date" v-model="instanceModal.dateOp" class="form-control" />
										</div>
										<div class="col-md-4">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.cost')}}
											</label>
											<input type="number" step="any" v-model="instanceModal.cost" class="form-control" />
										</div>

									</div>
								</form>
							</b-container>
							

						</div> <!-- modal-body  -->
						<div class="modal-footer">
							<div class="row d-flex justify-content-end mb-3">
								<!-- <input type="hidden" id="id" name="id" :value="user.id" required> -->

								<!-- INFO v-if="!dataMapShow.readOnlyShow" -->
								<div class="mr-3">
									<button class="btn btn-success" :disabled="loading" @click="axiosPost">
										<span v-show="loading" class="spinner-border spinner-border-sm"/>
										<!-- v-if="!dataMapShow.infos.id" -->
										<span >
											{{ $t('default.button.create') }}
										</span>
										<!-- <span v-if="dataMapShow.infos.id">
											{{ $t('default.button.update') }}
										</span> -->
									</button>
								</div>
								<button type="button" class="btn btn-danger ml-1" @click="modalToggle()">
									{{ $t('default.button.cancel') }}
								</button>
							</div>
						</div> 


					</div> <!-- modal-content  -->
				</div> <!-- modal-dialog  -->
			</div> <!-- ModalInstance  -->
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	export default {
		name: 'servOp',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('servop.label'),
				pageTitle: this.$t('servop.list'),
				pageIcon: 'recycle',
				instanceClassAttr: {
					instanceClass: 'servop',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: false, 
						thCol: '10%', 
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: true, 
						actPrint: 'produce'
					},
					attrsList: [
						// {attrName: 'id', attrCol: '5%', searchable: true, sortable: true, attrRep: ''},
						{attrName: 'dateOp', attrCol: '7%', searchable: false, sortable: true},
						{attrName: 'observation', attrCol: '15%', searchable: false, sortable: true, attrRep: 'getInstanceLinked()'},
						{attrName: 'quantity', attrCol: '7%', searchable: false, sortable: true},
						{attrName: 'cost', attrCol: '7%', searchable: false, sortable: true},
						{attrName: 'servTypeStockESLib', attrCol: '25%', searchable: false, sortable: true},
						{attrName: 'usernameLib', attrCol: '15%', searchable: true, sortable: false}
					]
				},
				instance: {
					prsStore: [],
					username: [],
					servService: [],
					servCategory: [],
					servTypeStockES: [],
					servTypeES: [],
					servType: [],
					dateEntryAfter:'',
					dateEntryBefore:''
				},
				prsStoreList: [],
				userList: [],
				servServiceList: [],
				servCategoryList: [],
				servTypeStockESList: [],
				servTypeESList: [],
				servTypeList: [],
				chartOptions: {
					title: 'Statistique des opérations par ',
					hAxis: {title: 'Désignation'},
					vAxis: {title: 'Quantité'},
					recap: {title: 'Quantités totales', val:0}
				},
				chartData: [],
				typeStats: [
					{id: 'servType', label: this.$t('servtype.label')},
					{id: 'servService', label: this.$t('servservice.label')},
					{id: 'servTypeES', label: this.$t('servtypees.label')}
					
				],
				typeStat: 'servType',
				instanceModal: {
					servTypeStockES: [],
					quantity: 0,
					cost: 0,
					dateOp: '',
					username: this.$store.getters.username
				},
				active: false,
				modalType: 'NEW',
				loading: false,
					
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
					if(this.$store.getters.isAuthorized(['ROLE_VENTE','ROLE_STOCK', 'ROLE_PROD'])){
						this.prsStoreList = this.prsStoreList.filter(item => item.id == this.$store.getters.prsInfo.prsStore)
						this.instance.prsStore = [this.$store.getters.prsInfo.prsStore]
					}
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				// GET LIST user
				await this.$store.dispatch('axiosGet', {
					domain: 'user'
				})
				.then(response => {
					// this.userList = response.data
					response.data.forEach(element => {
						this.userList.push(element.username)
						if(!this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
							this.userList = this.userList.filter(item => item == this.$store.getters.username)
							this.instance.username.push(this.$store.getters.username)
						}
					});
				})
				.catch(error => {
					console.log('error catch userList == ', error.message)
				})
				// GET LIST servServiceList
				await this.$store.dispatch('axiosGet', {
					domain: 'servservice'
				})
				.then(response => {
					this.servServiceList = response.data
				})
				.catch(error => {
					console.log('error catch servServiceList == ', error.message)
				})
				// GET LIST servCategoryList
				await this.$store.dispatch('axiosGet', {
					domain: 'servcategory'
				})
				.then(response => {
					this.servCategoryList = response.data
				})
				.catch(error => {
					console.log('error catch servcategory == ', error.message)
				})
				// GET LIST servTypeStockESList
				await this.$store.dispatch('axiosGet', {
					domain: 'servtypestockes'
				})
				.then(response => {
					this.servTypeStockESList = response.data
				})
				.catch(error => {
					console.log('error catch servTypeStockESList == ', error.message)
				})
				// GET LIST servTypeList
				await this.$store.dispatch('axiosGet', {
					domain: 'servtype'
				})
				.then(response => {
					this.servTypeList = response.data
				})
				.catch(error => {
					console.log('error catch servTypeList == ', error.message)
				})

				// GET LIST servTypeESList
				await this.$store.dispatch('axiosGet', {
					domain: 'servtypees'
				})
				.then(response => {
					this.servTypeESList = response.data
				})
				.catch(error => {
					console.log('error catch servTypeESList == ', error.message)
				})
				this.$nextTick(function () {	
					this.drawChart()
				});
				this.search();
			}
			// this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					// prsStore: [],
					// username: [],
					servService: [],
					servCategory: [],
					servTypeStockES: [],
					servTypeES: [],
					servType: [],
					dateEntryAfter:'',
					dateEntryBefore:''
				};
				if(this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					this.instance.prsStore = []
					this.instance.username = []
				}
				// if(!this.$store.getters.isAuthorized(['ROLE_VENTE','ROLE_STOCK'])){
				// 	this.instance.prsStore = []
				// }
			},
			async search() {
				let strParamsForms = "";
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';
				// Date super
				strParamsForms = strParamsForms+"&params1=dateOp&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}

				// Date inf
				strParamsForms = strParamsForms+"&params2=dateOp&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}
				strParamsForms = strParamsForms+"&params3=servTypeStockES.id&valParams3="+this.instance.servTypeStockES +"&logParams3=inL"
				if(this.instance.servTypeStockES && this.instance.servTypeStockES.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servTypeStockESList, this.instance.servTypeStockES, 'lib')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servTypeStockES')+'(s) : </i><b>'+strLibs + '</b>'
				}

				strParamsForms = strParamsForms+"&aliasList=_servTypeStockES,_servTypeStockES.servType"
				strParamsForms = strParamsForms+"&params4=_servTypeStockES.servTypeES.id&valParams4="+this.instance.servTypeES +"&logParams4=inL"
				if(this.instance.servTypeES && this.instance.servTypeES.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servTypeESList, this.instance.servTypeES, 'typeESName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servTypeES')+'(s) : </i><b>'+strLibs + '</b>'
				}
				strParamsForms = strParamsForms+"&params5=_servTypeStockES.servService.id&valParams5="+this.instance.servService +"&logParams5=inL"
				if(this.instance.servService && this.instance.servService.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servServiceList, this.instance.servService, 'serviceName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servService')+'(s) : </i><b>'+strLibs + '</b>'
				}
				
				// A revoir store & category
				strParamsForms = strParamsForms+"&params6=_servType.servCategory.id&valParams6="+this.instance.servCategory +"&logParams6=inL"
				if(this.instance.servCategory && this.instance.servCategory.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servCategoryList, this.instance.servCategory, 'categoryName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servCategory')+'(s) : </i><b>'+strLibs + '</b>'
				}
				
				strParamsForms = strParamsForms+"&params7=_servTypeStockES.servType.id&valParams7="+this.instance.servType +"&logParams7=inL"
				if(this.instance.servType && this.instance.servType.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servTypeList, this.instance.servType, 'typeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servType')+'(s) : </i><b>'+strLibs + '</b>'
				}
				strParamsForms = strParamsForms+"&params8=username&valParams8="+this.instance.username +"&logParams8=inS"

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				// default values
				let statLabel = [this.$t('servtype.label'), "Qté par article"] 
				let attrKey = ''
				let attrValue = 'quantity'

				if(this.typeStat === 'servType' )
					attrKey = 'servTypeStockES.servType.typeName'
				else if(this.typeStat === 'servService' ){
					statLabel = [this.$t('servservice.label'), "Qté par Service"]
					attrKey = 'servTypeStockES.servService.serviceName'
				}
				else if(this.typeStat === 'servTypeES' ){
					statLabel = [this.$t('servtypees.label'), "Qté par Type E/S"]
					attrKey = 'servTypeStockES.servTypeES.typeESName'
				}

				// var dataList = []
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				
				this.chartData = [ statLabel ]
				let sumData = 0;
				dataList?.forEach(data => {
					this.chartData.push(data);
					sumData = sumData + data[1]
				});
				this.chartOptions.recap.val = this.$store.getters.formatNumber(sumData)
			},
			modalToggle(type) {
				// this.resetModal()
				this.modalType = type
				// this.language = this.$store.getters.language
				if(this.active)
					this.active = false
				else{
					this.active = true
					this.$nextTick(function(){
						// this.axiosShow(this.modalType)
					});
				}
			},
			async axiosPost() {
				try {
					await this.$store.dispatch('axiosPost', {
						domain: 'servop',
						data: this.instanceModal //data
					})
					.then(res => {
						this.instanceModal = res.data;
						// console.log('res.data ', res.data)
						this.modalToggle(this.modalType)
						this.$nextTick(() => {
							let msg = this.$t("servop.label") + " "+res.data.id;
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('toast.created.message', { obj: msg})
							});
						});
					})
					.catch(error => {
						console.log('Error', error.response)
					})
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
		}
		
	}

</script>